// external dependencies
import React from 'react'
import { object, shape } from 'prop-types'
import { graphql } from 'gatsby'

// components
import SEO from 'components/Seo'
import SectionTopBrands from 'components/SectionTopBrands'
import SectionRfq from 'components/SectionRfq'
import Layout from 'components/layout/Barracuda'

const BarracudaTemplate = ({ data, pageContext }) => {
	// SectionAppeal markdown and hero images from frontmatter
	const appealMdx = data.appealContent.edges[0].node.code.body
	const appealFrontmatter = data.appealContent.edges[0].node.frontmatter
	// SectionTopBrands
	const topBrandsMdx = data.sectionTopBrands.edges[0].node.code.body
	const topBrandsLogos = data.sectionTopBrands.edges[0].node.frontmatter.images
	// SectionRfq
	const rfqMdx = data.sectionRfq.edges[0].node.code.body
	// pageContext defined in createPage for gatsby-node.js
	const { category } = pageContext

	return (
		<Layout appealMdx={appealMdx} appealFrontmatter={appealFrontmatter}>
			<SEO title={`BuyerZone.com - ${category}`} keywords={[category]} />
			<SectionRfq rfqMdx={rfqMdx} />
			<SectionTopBrands topBrandsMdx={topBrandsMdx} topBrandsLogos={topBrandsLogos} />
		</Layout>
	)
}

BarracudaTemplate.propTypes = {
	data: shape({
		sectionRfq: object.isRequired,
		sectionTopBrands: object.isRequired,
		appealContent: object.isRequired,
	}),
}

export default BarracudaTemplate

export const query = graphql`
	query($pathName: String!, $template: String!) {
		appealContent: allMdx(
			filter: { frontmatter: { component: { eq: "sectionAppeal" }, path: { eq: $pathName } } }
		) {
			totalCount
			edges {
				node {
					code {
						body
					}
					frontmatter {
						heroImageSm {
							childImageSharp {
								fluid(maxWidth: 450, quality: 100) {
									src
								}
							}
						}
						heroImagePositionSm
						heroImageMd {
							childImageSharp {
								fluid(maxWidth: 768, quality: 100) {
									src
								}
							}
						}
						heroImagePositionMd
						heroImageLg {
							childImageSharp {
								fluid(maxWidth: 1440, quality: 100) {
									src
								}
							}
						}
						heroImagePositionLg
						heroImageXl {
							childImageSharp {
								fluid(maxWidth: 2560, quality: 100) {
									src
								}
							}
						}
						heroImagePositionXl
					}
				}
			}
		}
		sectionTopBrands: allMdx(
			filter: {
				frontmatter: {
					template: { eq: $template }
					component: { eq: "sectionTopBrands" }
					path: { eq: $pathName }
				}
			}
		) {
			totalCount
			edges {
				node {
					code {
						body
					}
					frontmatter {
						images {
							childImageSharp {
								fixed(width: 128, quality: 100) {
									...GatsbyImageSharpFixed_noBase64
									...GatsbyImageSharpFixed_withWebp_noBase64
								}
							}
						}
					}
				}
			}
		}
		sectionRfq: allMdx(
			filter: {
				frontmatter: { template: { eq: $template }, component: { eq: "sectionRfq" }, path: { eq: $pathName } }
			}
		) {
			totalCount
			edges {
				node {
					code {
						body
					}
				}
			}
		}
	}
`
